// extracted by mini-css-extract-plugin
export var standaloneTable = "_fv-0";
export var standaloneTableWithBodyFill = "_fv-1";
export var withExtraHeader = "_fv-2";